import React, { forwardRef } from 'react';
import styles from './List.module.scss';
import { Image, Link } from '@sitecore-jss/sitecore-jss-react';
import NewsArrow from '../../../../Icons/NewsArrow';

const NewsListArticleList = forwardRef(function List({ articles }, ref) {
  return (
    <ul ref={ref} className={styles.list}>
      {(articles || []).map((item) => (
        <li key={item.id} className={styles.card} data-aos="fade-up">
          <a href={item.url}>
            <Image field={item.fields.detail.fields.image} width={750} height={495}></Image>
            {/* <h3 className={styles.card_subtitle}>{item.fields.detail.fields.subtitle.value}</h3> */}
            <div className={styles.card_content}>
              <div className={styles.card_content_left}>
                <h2 className={styles.card_content_left_title}>
                  {item.fields.detail.fields.title.value}
                </h2>
                <p className={styles.card_content_left_text}>
                  {item.fields.detail.fields.date.value}
                </p>
              </div>
              <div className={styles.card_content_right}>
                <NewsArrow />
              </div>
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
});

export default NewsListArticleList;
